/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";

export default function ReviewModal({
  show,
  onClose,
  tenantId,
  newReview,
  setNewReview,
  addStoreReview,
  getStoreReviews,
  setStoreReviews,
  theme
}) {
  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[20000] bg-gradient-to-br ${theme.bgGradient} overflow-y-auto p-0`}
      onClick={onClose}
    >
      <div
        className="w-full min-h-screen flex flex-col bg-transparent shadow-2xl relative p-6"
        onClick={(e) => e.stopPropagation()}
      >
        {/* العنوان */}
        <h3 className="text-xl font-bold text-white mb-4 text-center">
          قيّم تجربتك معنا ⭐
        </h3>

        {/* التقييم */}
        <div className="mb-4">
          <label className="block text-sm text-white/70 mb-1">
            التقييم
          </label>
          <select
            value={newReview.rating}
            onChange={(e) =>
              setNewReview({ ...newReview, rating: e.target.value })
            }
            className="w-full rounded-xl px-4 py-2 text-sm outline-none"
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              color: "white",
              border: `1px solid ${theme.primary}55`,
              backdropFilter: "blur(10px)"
            }}
          >
            {[5, 4, 3, 2, 1].map((v) => (
              <option key={v} value={v}>
                {v} نجوم
              </option>
            ))}
          </select>
        </div>

        {/* الوصف */}
        <div className="mb-5">
          <label className="block text-sm text-white/70 mb-1">
            رأيك
          </label>
          <textarea
            placeholder="اكتب رأيك هنا..."
            value={newReview.description}
            onChange={(e) =>
              setNewReview({ ...newReview, description: e.target.value })
            }
            className="w-full rounded-xl px-4 py-3 text-sm resize-none outline-none"
            rows={4}
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              color: "white",
              border: `1px solid ${theme.primary}55`,
              backdropFilter: "blur(10px)"
            }}
          />
        </div>

        {/* الأزرار */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2 rounded-full text-sm"
            style={{ backgroundColor: "#333", color: "#ccc" }}
          >
            إلغاء
          </button>

          <button
            onClick={async () => {
              const customer = JSON.parse(localStorage.getItem("storeCustomer"));

              const payload = {
                tenantId,
                customerName:
                  customer?.customerName || customer?.name || "Customer",
                rating: Number(newReview.rating),
                description: newReview.description
              };

              const res = await addStoreReview(payload);

              if (res?.success) {
                // ✅ أعد الجلب من السيرفر (المصدر الحقيقي)
                const updated = await getStoreReviews(tenantId);

                if (updated?.success) {
                  setStoreReviews(
                    (updated.data || []).filter(r => Number(r.isActive) === 1)
                  );
                }

                setNewReview({ rating: 5, description: "" });
                onClose();
              }
            }}
            className="flex-1 py-2 rounded-full text-sm font-semibold"
            style={{
              background: `linear-gradient(135deg, ${theme.primary}, ${theme.primaryDark})`,
              color: "white"
            }}
          >
            إرسال التقييم
          </button>


        </div>
      </div>
    </div>
  );
}
